export default __webpack_public_path__ + "static/media/indicator-quote2.1ba2d662.svg";